import React, { useEffect } from "react";
import AppRoute from "./route";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PopUpProvider from "./context/PopUpProvider";
import { AuthProvider } from "./hooks/useAuth";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import OfflineDetector from "./components/OfflineDetector";
import LoyaltyPromoPopup from "./components/LoyaltyPromoPopup";
function Layout() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isAccountsRoute = location.pathname.startsWith("/accounts");
  const isBusinessRoute = /^\/business($|\/)/.test(location.pathname);
  const isVolunteerRoute = /^\/volunteer(\/|$)/.test(location.pathname);
  const isInfoPage =
    /^\/(member-benefits-info|business-benefits-info|company-benefits-info)$/.test(
      location.pathname
    );

  // Only show Header and Footer for general users and info pages
  const showHeaderFooter =
    (!isAdminRoute && !isAccountsRoute && !isBusinessRoute && !isVolunteerRoute) || isInfoPage;
  return (
    <div className="min-h-screen flex flex-col overflow-x-clip font-poppins">
      {showHeaderFooter && (
        <Header className="fixed top-0 left-0 right-0 z-50 shadow-lg py-4 mb-4 bg-transparent" />
      )}
      <main
        className="flex-grow relative bg-white"
      >
        <AppRoute />
      </main>
      {showHeaderFooter && <Footer className="relative z-10" />}
      <ToastContainer />
      <PWAInstallPrompt />
      <OfflineDetector />
      <LoyaltyPromoPopup />
    </div>
  );
}
export default function App() {
  return (
    <AuthProvider>
      <PopUpProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Layout />
        </BrowserRouter>
      </PopUpProvider>
    </AuthProvider>
  );
}
